import { For, type JSX, Show } from 'solid-js';

// The Command Deck's tooltip (#6778, prototype `.fl-tip`): three lines for the pill under
// the pointer, or a "+N" pill's list of the items its lane could not fit. Rendered inside
// the section (no node left on `document.body`) and fixed to the pointer, kept 8 px inside
// the window.

export type TipState = {
  readonly x: number;
  readonly y: number;
  readonly title: string;
  /** An item pill's state and place. */
  readonly state?: string;
  readonly where?: string;
  /** A "+N" pill's hidden items, and the "and N more" past them. */
  readonly lines?: readonly string[];
  readonly more?: string | null;
};

export function FleetLiveTip(props: { readonly tip: TipState | null }): JSX.Element {
  return (
    <Show when={props.tip}>
      {(tip) => (
        <div
          class="fleet-live__tip"
          role="tooltip"
          style={{
            left: `${Math.max(8, Math.min(globalThis.innerWidth - 296, tip().x + 14))}px`,
            top: `${Math.min(globalThis.innerHeight - 90, tip().y + 16)}px`,
          }}
        >
          <b>{tip().title}</b>
          <Show when={tip().lines}>
            {(lines) => (
              <ul class="fleet-live__tip-list">
                <For each={lines()}>{(line) => <li>{line}</li>}</For>
              </ul>
            )}
          </Show>
          <Show when={tip().more}>
            {(more) => <span class="fleet-live__tip-where">{more()}</span>}
          </Show>
          <Show when={tip().state !== undefined}>
            {tip().state}
            <br />
            <span class="fleet-live__tip-where">{tip().where}</span>
          </Show>
        </div>
      )}
    </Show>
  );
}
